import { Injectable } from '@angular/core';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { environment } from '../../../environments/environment';

/**
 * Carga única de la API JS de Google Maps con el loader oficial (`setOptions` + `importLibrary`).
 * Librerías: maps, marker (AdvancedMarkerElement) y places (PlaceAutocompleteElement).
 * Sin llave en el environment no carga nada (el mapa muestra un aviso).
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {

  private ready?: Promise<boolean>;
  private configured = false;

  get hasKey(): boolean { return !!environment.googleMapsApiKey; }

  // region load
  /** `true` cuando maps, marker y places están listos; `false` sin llave o si falló la carga (se reintenta). */
  load(): Promise<boolean> {
    if (!this.hasKey) return Promise.resolve(false);
    this.ready ??= this.importAll().catch(() => {
      this.ready = undefined;
      return false;
    });
    return this.ready;
  }

  private async importAll(): Promise<boolean> {
    if (!this.configured) {
      setOptions({
        key: environment.googleMapsApiKey,
        v: 'weekly',
        language: 'es',
        region: 'MX',
        libraries: ['maps', 'marker', 'places'],
      });
      this.configured = true;
    }
    await Promise.all([importLibrary('maps'), importLibrary('marker'), importLibrary('places')]);
    return true;
  }
}
